import React from 'react';
import { useMessages } from '@ynap/immutables-provider';

// note, wrapping these in tags - these need to be react function components for hooks to work.

export const DetailsAndCareTitleDefault = () => {
    const detailsAndCare = useMessages((messages) => messages.accordionTitles.detailsAndCare);
    return <>{detailsAndCare()}</>;
};

export const DetailsAndCareTitleWatches = () => {
    const technicalSpecification = useMessages((messages) => messages.accordionTitles.technicalSpecification);
    return <>{technicalSpecification()}</>;
};
